import DashboardCtrl from './dashboard.controller';
import dashboardTiles from './directives/dashboard-tiles';
import newsFeed from './directives/news-feed';
import tile from './directives/tile';
import subscriberFlowWidget from './directives/subscriber-flow-widget';
import Dashboard from './dashboard.repository';

export default angular.module('app.dashboard', [])
    .controller('DashboardCtrl', DashboardCtrl)
    .directive('dashboardTiles', () => new dashboardTiles)
    .directive('tile', () => new tile)
    .directive('newsFeed', () => new newsFeed)
    .directive('subscriberFlowWidget', () => new subscriberFlowWidget)
    .service('Dashboard', Dashboard)
    .name;
